import React from 'react';
import { Col } from 'react-flexbox-grid';
import { Newsletter } from 'components';
import './BlogNewsletter.scss';

const BlogNewsletter = () => (
  <Col sm={12} md={6} lg={4}>
    <div className={'blog-newsletter'}>
      <Newsletter short />
    </div>
  </Col>
);

export default BlogNewsletter;
